<div class="multi-select-dropdown" appClickedOutside (clickOutside)="closeDropdown()">
    <div class="dropdown-trigger" [ngClass]="{'is-invalid':isSubmitted && selectItems && selectItems.length == 0}"
        [class.open]="isDropdownOpen" (click)="toggleDropdown()" tabindex="0">
        <span class="dropdown-display">
            @if (selectItems?.length) {
            <div class="chips">
                @for(item of selectItems?.controls | slice:0:2; track item.value){
                <span>
                    {{item.value}}
                    <!-- <i (click)="removeItemFromArray($index)">×</i> -->
                </span>
                }
                @if(selectItems && selectItems.length > 2){
                <span class="more">
                    +{{selectItems && selectItems.length - 2 }} more
                </span>
                }

            </div>
            } @else {
            <span class="dropdown-placeholder">Select {{title}}</span>
            }
        </span>
    </div>

    @if (isDropdownOpen) {
    <div class="dropdown-content" (click)="$event.stopPropagation()">
        <div class="dropdown-search">
            <input type="text" class="search-input" [placeholder]="'Search By ' + title" [(ngModel)]="searchTerm"
                (input)="onSearch($event)">
            <div class="search-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                </svg>
            </div>
        </div>
        @if(selectAll){
            <div class="select-all">
                <label class="checkbox-label" [ngClass]="{'custom-width': customWidth() }">
                    <input type="checkbox" [checked]="isAllChecked()" (change)="onSelectAllChanged($event,getFilteredOptions())">
                    <span class="checkbox-custom"></span>
                    <span class="option-text">Select All</span>
                </label>
                <label class="danger" (click)="onClearAll(getFilteredOptions())">Clear All</label>

            </div>
        }


        <div class="dropdown-options">
            @for (option of getFilteredOptions(); track option.id) {
            <div class="option-item" [class.has-children]="option.children">
                <div class="option-content">
                    @if (option.children) {
                        <span class="expand-icon" (click)="option.expanded = !option.expanded">
                            {{ option.expanded ? '▼' : '▶' }}
                        </span>
                    }
                    <label [class]="'checkbox-label'">
                        <input type="checkbox" (change)="onOptionChanged($event,option)" [value]="option.value"
                            [checked]="option.isSelected">
                        <span class="checkbox-custom" [class.minus]="option.indeterminate && !option.isSelected"></span>
                        <span class="option-text">{{ option.name }}</span>
                    </label>
                </div>

                @if (option.children && option.expanded) {
                <div class="nested-options">
                    @for (child of option.children; track child.id) {
                    <div class="option-item" [class.has-children]="child.children">
                        <div class="option-content">
                            @if (child.children && child.children.length > 0) {
                                <span class="expand-icon" (click)="child.expanded = !child.expanded">
                                    {{ child.expanded ? '▼' : '▶' }}
                                </span>
                            }
                            <label [class]="'checkbox-label'">
                                <input type="checkbox" [value]="child.value" (change)="onChildChanged($event,child,option)" 
                                    [checked]="child.isSelected">
                              <span class="checkbox-custom" [class.minus]="child.indeterminate && !child.isSelected"></span>
                                <span class="option-text">{{ child.name }}</span>
                            </label>
                        </div>

                        @if (child.children && child.expanded) {
                        <div class="nested-options">
                            @for (subChild of child.children; track subChild.id) {
                            <div class="option-item" [class.has-children]="subChild.children">
                                <div class="option-content">
                                    @if ( subChild.children && subChild.children.length > 0) {
                                        <span class="expand-icon" (click)="subChild.expanded = !subChild.expanded">
                                            {{ subChild.expanded ? '▼' : '▶' }}
                                        </span>
                                    }
                                    <label [class]="'checkbox-label'">
                                        <input type="checkbox" [value]="subChild.value" (change)="onSubChildChanged($event,subChild,child,option)"
                                            [checked]="subChild.isSelected">
                                        <span class="checkbox-custom" [class.minus]="subChild.indeterminate && !subChild.isSelected"></span>
                                        <span class="option-text">{{ subChild.name }}</span>
                                    </label>
                                </div>

                                @if (subChild.children && subChild.expanded) {
                                <div class="nested-options">
                                    @for (grandChild of subChild.children; track grandChild.value + ':' + grandChild.name) {
                                    <div class="option-item">
                                        <div class="option-content">
                                            <label [class]="'checkbox-label'">
                                                <input type="checkbox" [value]="grandChild.value" (change)="onGrandChildChanged($event,grandChild,subChild,child,option)"
                                                    [checked]="grandChild.isSelected">
                                                <span class="checkbox-custom"></span>
                                                <span class="option-text">{{ grandChild.name }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>
            }
            @if (getFilteredOptions().length === 0) {
            <div class="no-options">
                No {{title}} found
            </div>
            }
        </div>
    </div>
    }

    @if(isSubmitted && selectItems && selectItems.length == 0){
    <div class="invalid-feedback">
        <div>Please select at least one {{title.toLocaleLowerCase()}}</div>
    </div>
    }
</div>